import { requestToken } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/dashboard`;

class DashboardServices {
  async getStats() {
    try {
      const res = await requestToken.get(`${API_ROUTE}/stats`);
      return res?.data;
    } catch (error) {
      console.error("Error in getStats:", error);
      throw error;
    }
  }

  /** Super Admin only: online users in live sessions, by role (admin / outlet / mobile). */
  async getOnlineUsersByRole(opts = {}) {
    try {
      return await requestToken.get(`${API_ROUTE}/online-users-by-role`, undefined, {
        signal: opts.signal,
      });
    } catch (error) {
      if (
        opts.signal?.aborted ||
        error?.name === "AbortError" ||
        error?.code === "ERR_CANCELED"
      )
        return;
      console.error("Error in getOnlineUsersByRole:", error);
      throw error;
    }
  }

  async getAdminReportSummary() {
    try {
      const res = await requestToken.get(`${API_ROUTE}/admin-report-summary`);
      return res?.data;
    } catch (error) {
      console.error("Error in getAdminReportSummary:", error);
      throw error;
    }
  }

  async getAdminReportSummaryByFilter(params = {}) {
    try {
      const url = `${API_ROUTE}/admin-report-summary`;
      const res = await requestToken.get(url, {
        fromDate: params.fromDate,
        toDate: params.toDate,
        storeId: params.storeId,
      });
      // returns { isSuccess, data }
      return res;
    } catch (error) {
      console.error("Error in getAdminReportSummaryByFilter:", error);
      throw error;
    }
  }

  async getAdminRecentActivity(params = {}) {
    try {
      const url = `${API_ROUTE}/admin-recent-activity`;
      const res = await requestToken.get(url, {
        limit: params.limit,
        storeId: params.storeId,
      });
      // returns { isSuccess, data }
      return res;
    } catch (error) {
      console.error("Error in getAdminRecentActivity:", error);
      throw error;
    }
  }
}

export default new DashboardServices();
